import { render, staticRenderFns } from "./HandoverTakebackInformation.vue?vue&type=template&id=b64567fc&"
import script from "./HandoverTakebackInformation.vue?vue&type=script&lang=js&"
export * from "./HandoverTakebackInformation.vue?vue&type=script&lang=js&"
import style0 from "./HandoverTakebackInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b64567fc')) {
      api.createRecord('b64567fc', component.options)
    } else {
      api.reload('b64567fc', component.options)
    }
    module.hot.accept("./HandoverTakebackInformation.vue?vue&type=template&id=b64567fc&", function () {
      api.rerender('b64567fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/hotb/HandoverTakebackInformation.vue"
export default component.exports